import {
    LOAD_DAYS_OFF_SUCCESS,
    UPDATE_DAYS_OFF_SUCCESS,
    RESET_DAYS_OFF
} from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_DAYS_OFF_SUCCESS:
            return action.payload;
        case UPDATE_DAYS_OFF_SUCCESS:
            return action.payload;
        case RESET_DAYS_OFF:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/restaurant/DaysOffReducer.js